import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CollectionStore from '../store/collection';
import '@fiverr/globals';
import translations from '../translations.en.json';
import GigCard from './GigCard';
import GigCardsRepeater from '../shared/gig_cards_repeater';
import enrichGigsData from '../utils/enrichGigsData';
import './style.scss';

class GigCards extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            unmounting: false,
            collections: false,
            gigsAssets: []
        };

        i18n.add(translations);

        this.getCollections = this.getCollections.bind(this);
        this.updateCollections = this.updateCollections.bind(this);
    }

    componentDidMount() {
        if (this.props.user) {
            this.getCollections().then((json) => { this.setState({collections: json}); });
        }

        if (this.props.shouldEnrichData) {
            enrichGigsData(this.props.gigs).then((assets) => { this.setState({gigsAssets: assets}); });
        }
    }

    updateCollections(collections, callback) {
        this.setState({ collections }, typeof callback === 'function' && callback);
    }

    getCollections() {
        const {gigs, user} = this.props,
            hearts = gigs.map((gig) => gig.gig_id);

        if (!user) {
            return;
        }

        return CollectionStore.getCollections(hearts).then((json) => { this.setState({collections: json}); return json; });
    }

    render() {
        const { gigs, user, cardSize, responsiveGrid, context, onLinkClick } = this.props,
            {collections, gigsAssets} = this.state;

        return (
            <GigCardsRepeater context={{ cardType: 'card', cardSize, collections, user, ...context }} responsiveGrid={responsiveGrid}>
                {gigs.map((gig, i) =>
                    <GigCard key={gig.gig_id} gig={gig} updateCollections={this.updateCollections} user={user} gigsAssets={gigsAssets} context={context} gigIndex={i} cardSize={cardSize} onLinkClick={onLinkClick}/>
                )}
            </GigCardsRepeater>
        );
    }
}

GigCards.propTypes = {
    responsiveGrid: PropTypes.bool,
    user: PropTypes.object,
    gigs: PropTypes.array,
    cardSize: PropTypes.string,
    context: PropTypes.shape({
        pageCtxId: PropTypes.string,
        refCtxId: PropTypes.string
    }),
    onLinkClick: PropTypes.func
};

GigCards.defaultProps = {
    cardSize: 'medium',
    context: {},
    responsiveGrid: false,
    onLinkClick: () => null
};

export default GigCards;



// WEBPACK FOOTER //
// ./src/mp_gig_card/index.js